/** Nomads-style pride line: the proudest TRUE claim, or nothing. Never a
 * shaming display — below the podium people are "one of N", not "#180". */
export interface Standing {
  /** ISO country code the person represents ('' when unknown). */
  country: string
  countryRank: number
  countryCount: number
  globalRank: number
  globalCount: number
}

export type StandingClaim =
  | { kind: 'global'; rank: number }
  | { kind: 'country'; rank: number; country: string }
  | { kind: 'representing'; country: string; count: number }

/** Ladder, as decided by the owner: worldwide podium beats the country
 * podium (needs 5+ compatriots) beats plain representing. */
export function standingClaim(standing: Standing | null | undefined): StandingClaim | null {
  if (!standing) return null
  if (standing.globalRank >= 1 && standing.globalRank <= 3 && standing.globalCount >= 5) {
    return { kind: 'global', rank: standing.globalRank }
  }
  if (
    standing.country &&
    standing.countryRank >= 1 &&
    standing.countryRank <= 3 &&
    standing.countryCount >= 5
  ) {
    return { kind: 'country', rank: standing.countryRank, country: standing.country }
  }
  if (standing.country && standing.countryCount >= 1) {
    return { kind: 'representing', country: standing.country, count: standing.countryCount }
  }
  return null
}
